const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const TabView = require("./TabView");
const URLMake = require("../../shared/URLMake");
const SupportTab = require("./SupportTab");
const Link = require("../core/view/Link");
const HelpMonster = require("./HelpMonster");

const styles = require("./styles/SupportView.css");

module.exports = createReactClass({
	displayName: "SupportView",

	propTypes: {
		tab: PT.string.isRequired,
		tabList: PT.arrayOf(PT.string).isRequired,
		tabMap: PT.object.isRequired,
		topic: PT.string,
		setNextScrollTo: PT.func.isRequired,
		useMinTabWidth: PT.bool,
	},

	componentDidUpdate: function(prevProps) {
		if (prevProps.tab !== this.props.tab) {
			this.props.setNextScrollTo("top");
		}
	},

	render: function() {
		const {
			tab,
			topic,
			tabMap,
			tabList,
			setNextScrollTo,
			useMinTabWidth,
		} = this.props;
		const tabProps = {
			topic,
			setNextScrollTo,
		};

		const selectedTab = tabList.indexOf(tab);
		const titles = tabList.map(t => tabMap[t].displayName);
		const tabEls = tabList.map(t => {
			const planningNewResourcesSection =
				t === "planning" ? (
					<div className={styles.planningNewResources}>
						We are developing new resources to help you use Beast Academy in the
						classroom. Watch for new materials here!
					</div>
				) : null;
			return (
				<div className={styles.tabContainer}>
					<div className={styles.body}>
						<SupportTab {...tabProps} copyFunc={tabMap[t].copyFunc} />
					</div>
					{planningNewResourcesSection}
				</div>
			);
		});
		const faqEl = (
			<div className={styles.teacherFaqContainer}>
				<div className={styles.faqLabel}>Frequently Asked:</div>
				<div className={styles.faqQuestionContainer}>
					<div className={styles.faqQuestion}>
						<Link to={URLMake.forSchoolSupport("reports", "locks")}>
							<span className={styles.questionText}>How do locks work?</span>
							<span className={styles.questionTextShort}>Locks</span>
						</Link>
					</div>
					<div className={styles.faqQuestion}>
						<Link to={URLMake.forSchoolSupport("planning", "sequence")}>
							<span className={styles.questionText}>
								How do I sequence materials?
							</span>
							<span className={styles.questionTextShort}>Sequencing</span>
						</Link>
					</div>
					<div className={styles.faqQuestion}>
						<Link
							to={URLMake.forSchoolSupport("reports", "reading-the-reports")}
						>
							<span className={styles.questionText}>
								How can I assess progress?
							</span>
							<span className={styles.questionTextShort}>Progress</span>
						</Link>
					</div>
					<div className={styles.faqQuestion}>
						<Link to={URLMake.forContact()}>
							<span className={styles.questionText}>Contact Us.</span>
							<span className={styles.questionTextShort}>Contact Us</span>
						</Link>
					</div>
				</div>
			</div>
		);
		return (
			<div className={styles.main}>
				<TabView
					title={"Support"}
					largeTitle={true}
					tabTitles={titles}
					tabs={tabEls}
					tabLinks={tabList.map(t => URLMake.forSchoolSupport(t))}
					selectedTab={selectedTab}
					tabTitleTextClass={styles.tabTitle}
					useMinTabWidth={useMinTabWidth}
					subtitleContent={faqEl}
				/>
				<HelpMonster pageType={"support"} />
			</div>
		);
	},
});
